import PropTypes from 'prop-types';
import InPlayMenu from './inplay-menu.js';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Module that displays InPlay sports and allows the user to switch between the sports.
 *
 * @class InPlayMenu
 * @name InPlayMenu
 * @memberof Mojito.Modules.InPlay
 */

/**
 * `InPlayMenu` prop types.
 *
 * @property {string} [selectedTab] - Selected tab id.
 * @property {Function} [cbSportClicked = ()=>{}] - Callback function triggered when a sport is clicked.
 * @property {boolean} [hasPendingGroups] - Indicates if there's ongoing data loading.
 * @property {Array<string>} [sportIds = []] - Ids of the InPlay sports.
 * @property {Array<string>} [favoriteEvents = []] - Array of favorite event ids.
 * @property {object} [eventGroups = {}] - Event groups of the InPlay sports.
 *
 * @memberof Mojito.Modules.InPlay.InPlayMenu
 */
const propTypes = {
    eventGroups: PropTypes.object,
    cbSportClicked: PropTypes.func,
    selectedTab: PropTypes.string,
    hasPendingGroups: PropTypes.bool,
    favoriteEvents: PropTypes.arrayOf(PropTypes.string),
    sportIds: PropTypes.arrayOf(PropTypes.string),
};

const defaultProps = {
    sportIds: [],
    eventGroups: {},
    favoriteEvents: [],
    cbSportClicked: noop,
};

export default UIView('InPlayMenu', InPlayMenu, propTypes, defaultProps);
